import React from "react"

import Logo from "../logo/logo.js"
import HeaderNav from '../headerNav/headerNav.js'
import HamburgerButton from "../hamburgerButton/hamburgerButton.js"
import { QRCodeModalProvider } from "../qrcodeModal/qrcodeModalContext.js";

import styles from "./header.module.scss"

const Header = ({ showCTA, useWhiteBg }) => {
  const [navExpanded, setNavExpanded] = React.useState(false)
  const [bgWhite, setBgWhite] = React.useState(!!useWhiteBg)

  let rootClassNames = [styles.root]
  if (navExpanded) {
    rootClassNames = rootClassNames.concat(styles.rootBoxShadow)
  }

  if (navExpanded) {
    rootClassNames = rootClassNames.concat(styles.expanded)
  }

  if (bgWhite || !!useWhiteBg) {
    rootClassNames = rootClassNames.concat(styles.rootBgWhite)
  }

  const setBackground = () => {
    if (window.scrollY > 0) {
      setBgWhite(true)
    } else if (window.scrollY === 0 && !useWhiteBg) {
      setBgWhite(false)
    }
  }

  React.useEffect(() => {
 
    if (window.scrollY > 0 || !!useWhiteBg) {
      setBgWhite(true)
    }

    let prevScrollpos = 0;
    
    window.addEventListener("scroll", () => {
      window.requestAnimationFrame(()=>{
        let currentScrollPos = window.pageYOffset;
        
        setBackground();

        if((currentScrollPos - prevScrollpos < 15 && currentScrollPos - prevScrollpos > 0) || (currentScrollPos - prevScrollpos > -8 && currentScrollPos - prevScrollpos < 0)){
          prevScrollpos = currentScrollPos;
          if(currentScrollPos < 631){
            document.getElementById("tf-header").classList.remove(styles.scrollDown);
          }
          return;
        };
        
        if(currentScrollPos < 631){
          document.getElementById("tf-header").classList.remove(styles.scrollDown);
          return;
        }

        if (prevScrollpos > currentScrollPos) {
          document.getElementById("tf-header").classList.remove(styles.scrollDown);
        } else {
          document.getElementById("tf-header").classList.add(styles.scrollDown);
        }

        prevScrollpos = currentScrollPos;  
      });
      
    
    });
  }, [useWhiteBg])

  return (
    <QRCodeModalProvider>
      <header id="tf-header" className={rootClassNames.join(' ')}>
        <div className={styles.paddingContainer}>
          <div className={styles.rootContainer}>
            <div className={styles.topContainer}>
              <Logo />
              <div className={styles.menuBtnContainer}>
                <HamburgerButton onClick={() => {
                  if (!navExpanded) {
                    setBgWhite(true)
                  }
                  setNavExpanded(!navExpanded)
                }} />
              </div>
            </div>
            <HeaderNav showCTA={showCTA} navExpanded={navExpanded} />
          </div>
        </div>
      </header>
    </QRCodeModalProvider>
  )
}

Header.defaultProps = {
  showCTA: true,
}

export default Header
